import React from "react";
import TextField from "../../../../Forms/TextField";

const BasicInfoFields = () => {
  return (
    <>
      <TextField
        label="Menu Label & Reward Page Header"
        name="navLabel"
        description="The label on the dashboard\'s navigation side menu. It also serves as the key word in the page\'s header. By default the keyword is \'Rewards\'."
      />
      <TextField
        label="Reward Sub Header"
        name="rewardHeroSubHeader"
      />
      <TextField
        label="Section Header"
        name="sectionHeader"
        description="Header for the main section of the page. Section Header and Text are required."
        required
      />
      <TextField
        label="Section Text"
        name="sectionCopy"
        description="Copy for the main section of the page. Section Header and Text are required."
        multiline
        resizable
        required
      />
      <TextField
        label="Question Header"
        name="questionHeader"
      />
      <TextField
        label="Question Text"
        name="questionText"
        multiline
        resizable
      />
    </>
  );
};

export default BasicInfoFields;